export interface ProcessStep {
  number: number
  title: string
  short: string
  lead: string
  points: string[]
  highlight?: string
  repeatsPerSprint?: boolean
}

export const processSteps: ProcessStep[] = [
  {
    number: 1,
    title: 'Analyse & Prozessaufnahme',
    short: 'Abläufe vor Ort verstehen',
    lead: 'Bevor eine Zeile Code entsteht, verstehen wir Ihre Prozesse – vor Ort und gemeinsam mit den Menschen, die täglich damit arbeiten.',
    points: [
      'Ist-Abläufe aufnehmen und dokumentieren',
      'Engpässe, Medienbrüche und manuelle Schritte erkennen',
      'Ziele und Prioritäten gemeinsam festlegen',
    ],
  },
  {
    number: 2,
    title: 'Angebot & Prototyp',
    short: 'Die Richtung sichtbar machen',
    lead: 'Sie erhalten ein transparentes Angebot – und einen Prototypen, der visuell zeigt, wohin die Reise gehen kann.',
    points: [
      'Visuelles Verständnis statt seitenlanger Lastenhefte',
      'Frühes Feedback, bevor entwickelt wird',
      'Klare Grundlage für Ihre Entscheidung',
    ],
  },
  {
    number: 3,
    title: 'Anforderungen in Häppchen',
    short: 'Module & Backlog',
    lead: 'Nach der Auftragserteilung teilen wir die Anforderungen in kleine, greifbare Module und Features auf und füllen damit das Backlog.',
    points: [
      'Große Anforderungen werden zu überschaubaren Features',
      'Die Projektleitung kann bei uns liegen – oder bei Ihnen',
      'Das Wissen über Ihre Software bleibt in Ihrem Unternehmen',
    ],
    highlight:
      'Sie entscheiden, wer das Backlog füllt: wir – oder Ihr Team mit unserer Unterstützung.',
  },
  {
    number: 4,
    title: 'Entwicklung in Sprints',
    short: '1–2 Wochen pro Sprint',
    lead: 'Die ersten Module oder Features wandern in einen Sprint von ein bis zwei Wochen. Am Ende steht ein Ergebnis, das Sie selbst testen können.',
    points: [
      'Kurze, feste Zyklen mit klarem Ziel',
      'Das Ergebnis wird Ihnen im Review vorgestellt',
      'Sie testen selbst und geben direkt Feedback',
    ],
    repeatsPerSprint: true,
  },
  {
    number: 5,
    title: 'Abnahme & Abrechnung',
    short: 'Nur zahlen, was da ist',
    lead: 'Erst wenn die Themen im Review abgenommen sind, stellen wir die Rechnung. Sie zahlen nur, was Sie bereits haben – Schritt für Schritt.',
    points: [
      'Abrechnung nach jeder Abnahme',
      'Volle Kostenkontrolle über die gesamte Laufzeit',
      'Kein Bezahlen für Dinge, die noch nicht existieren',
    ],
    highlight:
      'Software und Quellcode gehören zu 100 % Ihnen. Keine Lizenzen, keine sonstigen Kosten.',
    repeatsPerSprint: true,
  },
  {
    number: 6,
    title: 'Schrittweise produktiv',
    short: 'Früh nutzbar',
    lead: 'Ab einem gewissen Punkt überführen wir das System Schritt für Schritt ins Produktivsystem – so wird es nutzbar, lange bevor alles fertig ist.',
    points: [
      'Module gehen einzeln live',
      'Ihr Team profitiert früh im Projekt',
      'Kein riskanter Umstieg an einem Stichtag',
    ],
  },
  {
    number: 7,
    title: 'Fundament für Wachstum',
    short: 'Jederzeit erweiterbar',
    lead: 'So entsteht ein solides Fundament, das sich immer wieder mit neuen Features füllen lässt – denn auch Unternehmen und Prozesse entwickeln sich weiter.',
    points: [
      'Saubere, modulare Architektur',
      'Neue Anforderungen fließen einfach ins Backlog',
      'Ihre Software wächst mit Ihrem Unternehmen',
    ],
  },
  {
    number: 8,
    title: 'Support & Betreuung',
    short: 'Wir bleiben an Ihrer Seite',
    lead: 'Wenn die Anforderungen umgesetzt sind, lassen wir Sie nicht allein. Mit unseren Support-Paketen 1 bis 4 unterstützen wir Sie auch danach.',
    points: [
      'Vier Support-Pakete zur Auswahl',
      'Freiwillig – nicht verpflichtend, aber ratsam',
      'Die Serviceverträge werden jährlich abgerechnet',
    ],
  },
]
